var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0948 11.8049C14.2501 11.8049 15.9973 10.0577 15.9973 7.90244C15.9973 5.74718 14.2501 4 12.0948 4C9.93956 4 8.19238 5.74718 8.19238 7.90244C8.19238 10.0577 9.93956 11.8049 12.0948 11.8049Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0946 13.7559C8.18439 13.7559 5 16.3783 5 19.6095C5 19.8281 5.17171 19.9998 5.39024 19.9998H18.799C19.0176 19.9998 19.1893 19.8281 19.1893 19.6095C19.1893 16.3783 16.0049 13.7559 12.0946 13.7559Z",
    fill: "#BDBDBD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/User Icon.f2936db3e818b4875cc0960dddd2ae29.svg";
export { ForwardRef as ReactComponent };